import type { ApiConfiguration, PrivacyItem } from 'app/src/services/welfareportal/companyagreement-api'

// eslint-disable-next-line import/no-named-as-default
import z from 'zod'

export const privacyItemSchema: z.ZodType<PrivacyItem> = z.object({
  title: z.string(),
  subTitle: z.string().optional(),
  link: z.string().optional(),
})

export const apiConfigurationSchema: z.ZodType<ApiConfiguration> = z.object({
  mapType: z.string(),
  mapToken: z.string(),
  mapId: z.string(),
  merchandiseCategory: z.record(z.string(), z.array(z.string())).optional(),
  privacyList: z.record(z.string(), privacyItemSchema).optional(),
})
